import React from 'react';

import classNames from 'classnames';
import Image from 'next/image';

import { StaggeredChild } from '@/blocks/animations/AppearInView';
import { LinkI18n } from '@/i18n/routing';

import { PartnerItem } from '@/app/[lang]/about/sections/AboutPartnersSection/PartnersBlock';

import styles from './styles.module.scss';

export const AboutPartnerItem = ({ img, alt, link }: PartnerItem) => {
  return (
    <>
      {link ? (
        <LinkI18n href={link} target={'_blank'}>
          <StaggeredChild className={classNames(styles.wrapperItem, styles.wrapperLink)}>
            <div className={styles.wrapperIcon}>
              <Image src={img} alt={alt} />
            </div>
          </StaggeredChild>
        </LinkI18n>
      ) : (
        <StaggeredChild className={styles.wrapperItem}>
          <div className={styles.wrapperIcon}>
            <Image src={img} alt={alt} />
          </div>
        </StaggeredChild>
      )}
    </>
  );
};
